<template>
    <div :class="['search-form', {'planrv':isPlanRV}]">
        <div class="location dropdown" v-click-outside="closeDropdown">
            <div class="wrapper">
                <div v-if="!showLocationInput">
                    <span>
                        {{ getCityDisplay(selectedCity) }}
                        <a class="service-close" href="#" @click.prevent="deselectCity"><fa-icon :icon="['fas', 'xmark']" aria-hidden="true"></fa-icon></a>
                    </span>
                </div>
                <input v-if="showLocationInput" name="location" class="location-input" v-model="locationState.input" :placeholder="locationState.placeholder" @focus="focusLocation" type="text" @blur="onLocationBlur" />
                <a class="locations-icon" href="#" v-if="supportsCurrentLocation && showLocationInput && !locationState.input && locationState.placeholder === 'Where do you need service?'" @click.prevent="useCurrentLocation">
                    <i v-if="!currentLocationLoading"><fa-icon :icon="['fas', 'location-arrow']" aria-hidden="true"></fa-icon></i>
                    <i v-if="currentLocationLoading"><fa-icon :icon="['fas', 'spinner']" spin aria-hidden="true"></fa-icon></i>
                </a>
            </div>
            <div v-if="openDropDownId === 'location' && showLocationsHint" id="location-hint" class="hint">
                <p>Start typing the address</p>
            </div>
            <div v-if="locationError" class="validation-error"><p>{{locationError}}</p></div>
            <transition name="expand" appear>
                <div v-if="openDropDownId === 'location'">
                    <div v-if="citiesLoaded && cities.length > 0" class="content">
                        <ul>
                            <li v-for="city in cities">
                                <a href="#" @click.prevent="selectCity(city)">{{ getCityDisplay(city) }}</a>
                            </li>
                        </ul>
                    </div>
                    <div v-if="!citiesLoaded && locationState.input" class="placeholder">
                        <fa-icon :icon="['fas', 'spinner']" spin aria-hidden="true"></fa-icon>
                    </div>
                    <div class="validation-error hint" v-if="citiesLoaded && cities.length == 0 && locationState.input">Listing name is not valid.</div>
                </div>
            </transition>
        </div>
            <div class="region dropdown">
                <select v-model="searchType">
                    <option class="placeholder-option" value="">State/Prov/Type (optional)</option>
                    <optgroup label="United States">
                        <option v-for="rgn in usRegions" :value="rgn.code">{{ rgn.name }}</option>
                    </optgroup>

                    <optgroup label="Canada">
                        <option v-for="rgn in canadianRegions" :value="rgn.code">{{ rgn.name }}</option>
                    </optgroup>

                    <optgroup label="Other Search Types">
                        <option value="account">Account</option>
                        <option value="phone">Phone</option>
                        <option value="name">Name</option>
                    </optgroup>
                </select>
            </div>
            <div v-if="!isSpecialSearch" class="service dropdown" v-click-outside="closeDropdown">
                <div class="wrapper">
                    <div v-for="service in selectedServices">
                        <span>
                            {{ service.name }}
                            <a class="service-close" href="#" @click.prevent="deselectService(service.code)">
                                <fa-icon :icon="['fas', 'xmark']" aria-hidden="true"></fa-icon>
                            </a>
                        </span>
                    </div>
                    <input name="service" class="service-input" v-model="serviceState.input" :placeholder="serviceState.placeholder" @focus="focusService" type="text" />
                    <i class="service-icon" v-if="selectedServices.length === 0"><fa-icon :icon="['fas', 'screwdriver-wrench']" aria-hidden="true"></fa-icon></i>
                </div>
                <div v-if="openDropDownId === 'service' && (filteredServices.length > 0 || filteredNetworks.length > 0)" class="content service-content">
                    <div class="close-service-content">
                        <a class="service-close" href="#" @click.prevent="openDropdown('')">
                            <fa-icon :icon="['fas', 'xmark']" aria-hidden="true"></fa-icon>
                        </a>
                    </div>
                    <ul>
                        <li v-if="filteredServices"><span>Service</span></li>
                        <li v-for="service in filteredServices">
                            <a href="#" @click.prevent="selectService(service.code)">{{ service.name }}</a>
                        </li>
                    </ul>
                    <ul>
                        <li v-if="filteredNetworks"><span>Dealer Network</span></li>
                        <li v-for="network in filteredNetworks">
                            <a href="#" @click.prevent="selectService(network.code)">{{ network.name }}</a>
                        </li>
                    </ul>
                </div>
                <div v-if="servicesError" class="validation-error"><p>{{servicesError}}</p></div>

            </div>
            <div v-if="userInfo.isAuth" class="options dropdown">
                <button class="options-btn" v-if="showOptionsButton" @click="toggleOptions">Options</button>
                <!--drop down trigger-->
                <div v-if="showOptions" class="options-content content">
                    <div v-if="amenities.length > 0" class="filter dropdown">
                        <div class="wrapper" v-click-outside="closeDropdown">
                            <div v-for="amenity in selectedAmenities">
                                <span>
                                    {{ amenity.name }}
                                    <a class="service-close" href="#" @click.prevent="deselectAmenity(amenity.code)">
                                        <fa-icon :icon="['fas', 'xmark']" aria-hidden="true"></fa-icon>
                                    </a>
                                </span>
                            </div>
                            <input name="filter" class="options-input" v-model="optionsState.input" :placeholder="optionsState.placeholder" @focus="focusAmentity" type="text" />
                        </div>
                        <div v-if="openDropDownId === 'amenities'" class="options-content content">
                            <ul>
                                <li v-for="amenity in filteredAmenities">
                                    <a href="#" @click.prevent="selectAmenity(amenity.code)">{{ amenity.name }}</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <!--ACE only-->
                    <div v-if="userInfo.isFleet">
                        <label class="checkbox-label">
                            Suppress Managed Services
                            <input name="suppress" type="checkbox" v-model="suppressManaged" />
                            <span class="mark"></span>
                        </label>
                    </div>
                    <div v-if="userInfo.isFleet">
                        <label class="checkbox-label">
                            Search on Distance
                            <input name="distance" type="checkbox" v-model="searchOnDistance" />
                            <span class="mark"></span>
                        </label>
                    </div>
                </div>
            </div>

            <div v-if="captchaDisplay" class="search-btn-wrapper">
                <captcha :instance="captchaInstance"></captcha>
            </div>
            <div v-else-if="captchaIsBlocked" class="search-btn-wrapper">
                <p><strong>Security Alert:</strong> you have been blocked by our security systems.  Please <a href="/contact">contact us</a>.</p>
                <p>For more information about why we limit access, please read <a href="/why-we-limit-access">why we limit access</a>.</p>
            </div>
            <div v-else class="search-btn-wrapper" id="search-btn-wrapper">
                <button class="search-btn" @click="runSearch">Search</button>
            </div>
        </div>
</template>

<script>import script from './SearchForm';
    export default script;</script>

<style lang="less" scoped>
    @import "./SearchForm.less";
</style>